import { cva } from 'class-variance-authority';
import React from 'react';
import { twMerge } from 'tailwind-merge';

import type { ITagProps } from './ITagProps';

export const tagStyles = cva(
  'rounded py-[2px] pl-1 pr-[6px] text-white text-xs font-medium flex items-center gap-1 max-w-max',
  {
    variants: {
      intent: {
        success: 'bg-mobile-teal-500',
        subtle: 'bg-mobile-gray-400',
        neutral: 'bg-mobile-gray-500',
        caution: 'bg-mobile-beach-100',
        danger: 'bg-mobile-accent-error',
      },
    },
  },
);

const Tag = React.forwardRef<HTMLSpanElement, ITagProps>(
  (props: ITagProps, ref) => {
    const {
      text,
      intent,
      textColor,
      prefixIcon: PrefixIcon = null,
      className,
      children,
      statusBackgroundColor,
      ...rest
    } = props;

    let color = 'white';
    if (textColor) {
      color = textColor;
    }

    return (
      <span
        className={twMerge(tagStyles({ intent }), className)}
        ref={ref}
        style={{ backgroundColor: statusBackgroundColor }}
        {...rest}
      >
        {PrefixIcon && <PrefixIcon />}
        <span style={{ color }} className="capitalize">
          {text ?? children}
        </span>
      </span>
    );
  },
);

Tag.displayName = 'Tag';

export default Tag;
